module.exports = __webpack_public_path__ + "static/img/noData_big.d5ed98e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/noData_big.png
// module id = k51M
// module chunks = 44